var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserDialog',{attrs:{"inline":true,"user-id":_vm.userId}})
}
var staticRenderFns = []

export { render, staticRenderFns }